import * as config from "../../../util/config";

export const availableStepsAndPages = [
    "stepGeneralData",
    "stepTaxData",
    "stepLegalRepresentative",
    "stepShareholders",
    "stepProxies",
    "stepBeneficiaries",
    "stepDocumentation",
    "stepFinish",
    "stepPaywayFirst",
    "stepSelectPaywayTerminalType",
    "stepSelectPaywayCategory",
    "stepSavePaywayTerminalsData",
    "lastStepPayway",
];

export const getNextStep = (currentStep, role) => {
    const enabledPayway = config.getBoolean("onboarding.payway.enable", false);
    const currentStepIndex = availableStepsAndPages.indexOf(currentStep);
    const isStepTaxData = currentStep === "stepTaxData";
    const isStepFinish = !enabledPayway ? currentStep === "stepFinish" : currentStep === "lastStepPayway";
    const isLegalRepresentative = role === "REPRESENTANTE_LEGAL";

    if (isStepFinish) {
        return currentStep;
    }

    if (isStepTaxData && isLegalRepresentative) {
        return availableStepsAndPages[currentStepIndex + 2];
    }

    return availableStepsAndPages[currentStepIndex + 1];
};

export default availableStepsAndPages;
